

const Skeleton = ({ width = "300px" }) => {
    return (
        <div className="loading-card" style={{ width }}>
            <div className="skeleton-header"></div>
            <div className="skeleton-text"></div>
            <div className="skeleton-text"></div>
            <div className="skeleton-footer"></div>
        </div>
    )
}

export default Skeleton;

